export default __webpack_public_path__ + "static/media/key.c4f6be58.svg";